import type { RichTranslationValues } from 'next-intl';
import type { ReactNode } from 'react';

const tFooterCardEmValue: RichTranslationValues = {
  em: (chunks: ReactNode) => (
    <span className="self-end font-serif italic">{chunks}</span>
  ),
};

export default tFooterCardEmValue;
